import React from 'react';
import { IResponsiveImageSource } from '../../../ui';
import { ContactItem, ContactItemContainer } from '../../shared/components';
import { getResponsiveImageUrl } from '../../shared/image/getResponsiveImageUrl';

const testImage =
	'https://images.ctfassets.net/jaw4bomip9l3/5Gu8gZRexOh8FBpYZGmx3N/7ba6184b83bf7770588f39350e8be08c/lufthansa_3x.png';

const responsiveTestImage: IResponsiveImageSource = [
	getResponsiveImageUrl(testImage, { w: 720 }),
	{
		mobile: getResponsiveImageUrl(testImage, {
			w: 160,
			h: 200,
			fit: 'pad',
			bg: 'rgb:ffab00',
		}),
		mobileXL: getResponsiveImageUrl(testImage, {
			w: 480,
			h: 480,
			fit: 'pad',
			bg: 'rgb:ffab00',
		}),
	},
];

const contactItem = {
	title: 'Lufthansa',
	linkHref: 'https://www.lufthansa.com/',
	linkTitle: 'Go to website',
	imageSource: responsiveTestImage,
	imageAlt: 'Lufthansa',
	phoneNumber: '+49-800-8384267',
};

export const ContactItems = () => (
	<>
		<h2>Contact items</h2>
		<ContactItemContainer>
			<ContactItem {...contactItem} />
			<ContactItem {...contactItem} />
			<ContactItem {...contactItem} />
		</ContactItemContainer>
	</>
);
